import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.629 5.65c2.844-.211 5.59-.317 8.24-.317 2.712 0 5.424.11 8.136.331a4.278 4.278 0 0 1 3.915 3.89c.127 1.45.191 3.1.191 4.946 0 1.889-.067 3.637-.2 5.243a4.278 4.278 0 0 1-4.263 3.924H9.944a4.278 4.278 0 0 1-4.277-4.278V9.915c0-2.24 1.728-4.1 3.962-4.266Zm13.76 20.461a.611.611 0 0 1 0 1.222H8.722A6.722 6.722 0 0 1 2 20.611v-8.556a.611.611 0 0 1 1.222 0v8.556a5.5 5.5 0 0 0 5.5 5.5H23.39ZM6.889 9.915c0-1.6 1.234-2.929 2.83-3.047a110.49 110.49 0 0 1 8.15-.313c2.68 0 5.358.11 8.037.327a3.056 3.056 0 0 1 2.796 2.778c.125 1.414.187 3.027.187 4.84 0 1.856-.065 3.57-.196 5.142a3.055 3.055 0 0 1-3.045 2.802H9.944A3.056 3.056 0 0 1 6.89 19.39V9.915Z",
    fill: "currentColor"
  }));
};

var SvgShareScreen = styled(SvgComponent).withConfig({
  displayName: "ShareScreen__SvgShareScreen",
  componentId: "sc-1hw475n-0"
})(["", " ", ""], size, color);
export default SvgShareScreen;